'use strict';

// Hard-block mnemonic backup confirmation. After register we show the 12 words and
// require: (a) an explicit "I wrote it down" acknowledgement, AND (b) correctly
// re-entering 3 randomly chosen word positions. No skip — onConfirmed only fires
// when both pass.

const { $, renderMnemonic } = require('./views');

function pickIndices(count, max) {
  const set = new Set();
  while (set.size < count) set.add(1 + Math.floor(Math.random() * max));
  return [...set].sort((a, b) => a - b);
}

function start(phrase, onConfirmed) {
  renderMnemonic(phrase);
  const words = phrase.split(' ');
  const indices = pickIndices(3, words.length);

  const fields = $('confirm-fields');
  const ack = $('backup-ack');
  const cont = $('backup-continue');
  const err = $('backup-error');
  if (!fields || !cont) return;

  fields.innerHTML = '';
  const inputs = [];
  for (const i of indices) {
    const wrap = document.createElement('div');
    wrap.className = 'input-group';
    wrap.innerHTML = '<label>Confirm word #' + i + '</label>';
    const inp = document.createElement('input');
    inp.type = 'text';
    inp.autocomplete = 'off';
    inp.spellcheck = false;
    inp.dataset.index = String(i);
    inp.className = 'confirm-word';
    wrap.appendChild(inp);
    fields.appendChild(wrap);
    inputs.push(inp);
    inp.addEventListener('input', () => { if (err) err.textContent = ''; });
  }
  if (ack) { ack.checked = false; ack.addEventListener('change', () => { if (err) err.textContent = ''; }); }

  cont.onclick = () => {
    if (ack && !ack.checked) { if (err) err.textContent = 'Please confirm you have written down your recovery phrase.'; return; }
    const allCorrect = inputs.every((inp) => inp.value.trim().toLowerCase() === words[Number(inp.dataset.index) - 1].toLowerCase());
    if (!allCorrect) { if (err) err.textContent = 'Those words do not match your phrase. Check your written copy and try again.'; return; }
    onConfirmed();
  };
}

module.exports = { start };
